import { Subscription } from "rxjs";
import {
  EventEmitter,
  SimpleChange,
  Component,
  OnChanges,
  OnDestroy,
  Output,
  Input,
} from "@angular/core";

// Environments
import { environment } from "src/environments/environment";

// Libraries
import * as _ from "underscore";

// Services
import { PayNPlayCashierService } from "src/app/modules/account/services/pay-n-play-cashier.service";
import { UserDetailsService } from "src/app/modules/user/services/user-details.service";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { UtilityService } from "src/app/utility/utility.service";

@Component({
  selector: "app-deposit-reward-card",
  templateUrl: "./deposit-reward-card.component.html",
  styleUrls: ["./deposit-reward-card.component.scss"],
})
export class DepositRewardCardComponent implements OnChanges, OnDestroy {
  @Input() bonusDetails;
  @Input() callingFrom;
  @Input() rewardSize;
  @Output() callOpenRewardTCPopUp: EventEmitter<any> = new EventEmitter();

  /**this property is required only for payment bonus */
  @Input() selectedBonus;
  @Output() callOnBonusSelected: EventEmitter<any> = new EventEmitter();
  @Output() callOnNavigateToDeposit: EventEmitter<any> = new EventEmitter();

  mediaUrlPath: string = environment.mediaUrlPath;
  gamesUrlPath: string = environment.gamesUrlPath;
  bonusType: string;
  langCodeSub: Subscription;
  isRealUser: boolean = false;
  currencyCodeSub: Subscription;
  currencyCode: string;
  currencySymbolSubscription: Subscription;
  currencySymbol: string;
  imgixParams: string;

  constructor(
    private utility: UtilityService,
    private userDetailsService: UserDetailsService,
    private paynplayCashierService: PayNPlayCashierService,
    private commonService: CommonService
  ) {
    this.currencyCodeSub = this.userDetailsService.currencyCodeSb$.subscribe(
      (curreny) => {
        this.currencyCode = curreny;
      }
    );
    this.currencySymbolSubscription = this.userDetailsService.currencySymbolSb$.subscribe(
      (curSymbol) => {
        this.currencySymbol = curSymbol;
      }
    );
    if (this.userDetailsService.getUserProfileDetails()) {
      this.isRealUser =
        this.userDetailsService.getUserProfileDetails().userStatus === "real"
          ? true
          : false;
    }

    this.imgixParams = this.utility.getImgixParams();
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    if (changes["bonusDetails"]) {
      this.bonusDetails = changes["bonusDetails"].currentValue;
      this.bonusType = this.bonusDetails["bonusTypeFD"];
    }
    if (changes["callingFrom"]) {
      this.callingFrom = changes["callingFrom"].currentValue;
    }
    if (changes["selectedBonus"]) {
      this.selectedBonus = changes["selectedBonus"].currentValue;
      if (_.isEmpty(this.selectedBonus)) {
        this.clearSelectedBonus();
      }
    }
    if (changes["rewardSize"]) {
      this.rewardSize = changes["rewardSize"].currentValue;
      console.log("deposit reward card:", this.rewardSize);
    }
  }

  openDepositView(bonus) {
    if (this.utility.isPnpFlow()) {
      this.commonService.setActiveDepositBonus(bonus);
      if (this.callingFrom === "all-rewards") {
        this.paynplayCashierService.broadCastInitiateDeposit({
          callingFrom: this.callingFrom,
        });
        this.utility.closeAccountComponent();
      } else {
        this.callOnNavigateToDeposit.emit();
      }
    } else {
      this.commonService.setActiveDepositBonus(bonus);
      this.utility.initiateDeposit();
    }
  }

  clearSelectedBonus() {
    if (
      this.utility.isPnpFlow() &&
      !(
        this.selectedBonus &&
        this.selectedBonus["bonusCode"] === this.bonusDetails["bonusCode"]
      )
    ) {
      this.commonService.setActiveDepositBonus("");
    }
  }

  openRewardTCPopUp(event) {
    this.callOpenRewardTCPopUp.emit(event);
  }

  addBonus(bonusData) {
    this.commonService.setActiveDepositBonus(bonusData);
    this.utility.closeAccountComponent();
    if (["pnp-cashier"].indexOf(this.callingFrom) > -1) {
      this.callOnNavigateToDeposit.emit();
    } else {
      this.utility.initiateDeposit();
    }
  }

  selectBonusHanlder(bonus) {
    this.selectedBonus = bonus;
    this.commonService.setActiveDepositBonus(this.selectedBonus);
    this.callOnBonusSelected.emit(bonus);
    if (this.utility.isPnpFlow() && this.callingFrom === "customBanner") {
      this.callOnNavigateToDeposit.emit();
    }
  }

  ngOnDestroy() {
    this.currencyCodeSub.unsubscribe();
    this.currencySymbolSubscription.unsubscribe();
  }
}
